// removed by extract-text-webpack-plugin
module.exports = {"LoginImage":"_1q3QhOXWPYLWl-43EHD6ft","LoginLogo":"BwxYA1MM_hTIaNarOpgzs","LoginButton":"_2IT312S9-aPLqxhVJqE13O","LoginRegister":"_3CAb7N-5Q-QnSUdbv6A-v6","ForgotPassword":"__WHa1n3j982CV5Yq5DLg","errorMsg":"c1NhRE2vhJoMC9Vetchx7","Input":"_24WyQ_qAoizMq1ym2Tk05Q","InputLabel":"KOlP7Qq_WZI_1vfekdOAm","StoreIcon":"_QGLaOA58IvMFRZDCrHQN","LinkText":"_1HBOSJPgtpEfOdFJL8CE0b","MobileImage":"_3-wZ0V98QiWi2qQcShj8wD"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Login/style.css
// module id = 1311
// module chunks = 0